import { ca } from '@cian/analytics';

export type TMortgageRateHikeBannerProducts = Array<{
  id: number;
  offerType: string;
  position: number;
}>;

type TBannerAction = 'show_sopr' | 'click';

function trackBannerEvent(products: TMortgageRateHikeBannerProducts, action: TBannerAction) {
  ca('eventSite', {
    name: 'oldevent',
    action,
    category: 'MortgageRateHikeListing',
    label: 'banner',
    products,
  });
}

export function trackBannerShow(products: TMortgageRateHikeBannerProducts) {
  trackBannerEvent(products, 'show_sopr');
}

export function trackBannerClick(products: TMortgageRateHikeBannerProducts) {
  trackBannerEvent(products, 'click');
}
